
import ProductBrandNewComponent from "../../../components/product_brands/New.vue";

export default {
  components: {
    ProductBrandNewComponent
  }
};
